/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The TemplateQuantitativeDriverDTO model module.
 * @module model/TemplateQuantitativeDriverDTO
 * @version v0
 */
export class TemplateQuantitativeDriverDTO {
  /**
   * Constructs a new <code>TemplateQuantitativeDriverDTO</code>.
   * @alias module:model/TemplateQuantitativeDriverDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplateQuantitativeDriverDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplateQuantitativeDriverDTO} obj Optional instance to populate.
   * @return {module:model/TemplateQuantitativeDriverDTO} The populated <code>TemplateQuantitativeDriverDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplateQuantitativeDriverDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('position'))
        obj.position = ApiClient.convertToType(data['position'], 'Number');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
TemplateQuantitativeDriverDTO.prototype.id = undefined;

/**
 * @member {Number} position
 */
TemplateQuantitativeDriverDTO.prototype.position = undefined;

/**
 * @member {String} title
 */
TemplateQuantitativeDriverDTO.prototype.title = undefined;

